import { sharedEndpoints, authEndpoints } from "@src/services/endpoints";
import {
  DEFAULT_LANGUAGE,
  DEFAULT_INDUSTRY,
  STALE_TIME_1HS,
  USER_COOKIE,
} from "@src/constants/constants";
import { queryClient } from "@src/utils/queryClient";
import StorageUtils from "@src/utils/storageUtils";

const dcLoader = async () => {
  return queryClient.ensureQueryData({
    queryKey: ["DYNAMIC_CONTENT"],
    staleTime: STALE_TIME_1HS,
    queryFn: async () => {
      const currentUser = StorageUtils.getObjectItem(USER_COOKIE);
      const authUser = await authEndpoints.getMeIdentity(currentUser?.username);
      const dcIndustry = authUser?.metadata?.industry || DEFAULT_INDUSTRY;
      return sharedEndpoints.getDynamicContent(DEFAULT_LANGUAGE, dcIndustry);
    },
  });
};

export default dcLoader;
